module.exports = __webpack_public_path__ + "img/logo_color_white.f1695d7b.svg";